/**
 * Clears app-specific localStorage keys while preserving MSAL cache entries.
 * Using localStorage.clear() wipes MSAL tokens (cacheLocation: 'localStorage'),
 * which breaks SSO sessions and forces users to re-authenticate.
 */
export function clearMsalStorage(): void {
    const keysToRemove: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('msal.') || key.startsWith('msal'))) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
}

export function clearAppStorage(): void {
    const keysToRemove: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && !key.startsWith('msal.') && !key.startsWith('msal')) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
}
